import { DocumentNode, gql } from "@apollo/client";

class TestResultService {
  public static getTestResult = (): DocumentNode => gql`
    query GetTestResult($orderUidPublic: String!, $testUid: String!) {
      getTestResult(orderUidPublic: $orderUidPublic, testUid: $testUid) {
        orderUidPublic
        testUid
        testType
        organ
        documents {
          uid
          documentName
          contentType
        }
        reportGender
        caPnsSupplemental
        resultCode
        fetalSex
        releasedToPatientDate
        latestResultDocumentUid
        isTfMrdActive
        tfMrdOrderingOption
        isReflexed
        resultDocuments {
          releasedToProviderDate
          releasedToPatientDate
          scheduledPatientReleaseDate
          resultDate
          providerNotes
          document {
            uid
            url
            documentName
            documentType
            contentType
            content
            documentReferenceId
          }
        }
        businessUnit
      }
    }
  `;

  public static getTestResultInfoFromToken = (): DocumentNode => gql`
    query GetTestResultInfoFromToken($token: String!) {
      getTestResultInfoFromToken(token: $token) {
        orderUidPublic
        testUid
      }
    }
  `;

  public static getSupplementMaterial = (): DocumentNode => gql`
    query GetSupplementalMaterial(
      $orderUidPublic: String!
      $testUid: String!
      $documentUid: String!
    ) {
      getSupplementalMaterial(
        orderUidPublic: $orderUidPublic
        testUid: $testUid
        documentUid: $documentUid
      ) {
        uid
        documentName
        url
      }
    }
  `;

  public static AccessTestResults = (): DocumentNode => gql`
    mutation AccessTestResults($accessTestResults: AccessTestResultsDTO!) {
      accessTestResults(accessTestResults: $accessTestResults) {
        orderUidPublic
        success
      }
    }
  `;
}

export default TestResultService;
